import React, { FC, ReactNode } from 'react';
import { DocumentGroup } from '../../../../../../interfaces/DocumentGroup';
import { Document } from '../../../../../../interfaces/Document';
import Contracts from './Contracts';
import getGroupedContractsPeriod from './getGroupedContractsPeriod';

export interface GroupedContractProps {
  groups: DocumentGroup[];
  document: Document;
  children?: ReactNode;
}

const GroupedContract: FC<GroupedContractProps> = ({ groups, document }) => (
  document.grouped && document.date.getTime() === getGroupedContractsPeriod(groups, document.contract.systemCode).getTime()
    ? <Contracts groups={groups} document={document} key={document.id} />
    : null
);

export default GroupedContract;
